import React, { useState, useEffect, useLayoutEffect } from 'react';
import './ProyectosDestacados.css';
import ProjectDetailModal from './ProjectDetailModal';

// --- Tus importaciones de imágenes (sin cambios) ---
import projectImage1 from '../../uploads/proyectos/proyecto1.png';
import projectImage2 from '../../uploads/proyectos/proyecto2.png';
import projectImage3 from '../../uploads/proyectos/proyecto3.png';
import projectImage4 from '../../uploads/proyectos/proyecto4.png';
import projectImage5 from '../../uploads/proyectos/proyecto5.png';
import projectImage6 from '../../uploads/proyectos/proyecto6.png';
import projectImage7 from '../../uploads/proyectos/proyecto7.png';
import projectImage8 from '../../uploads/proyectos/proyecto8.png';
import projectImage9 from '../../uploads/proyectos/proyecto9.png';


// --- allProjects con las imágenes ---
const allProjects = [
  { id: 1, title: 'Interventoría Concesión Ruta del Sol Sector 2', categories: ['Viales', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Obras Públicas'], imageUrl: projectImage1 },
  { id: 2, title: 'Interventoría Concesión Bogotá (Fontibón) Facatativá – Los Alpes', categories: ['Viales', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Obras Públicas'], imageUrl: projectImage2 },
  { id: 3, title: 'Cruce de la Cordillera Central, Quindio, Tolima', categories: ['Viales', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Túneles', 'Obras Públicas'], imageUrl: projectImage3 },
  { id: 4, title: 'Concesión Cartagena – Barranquilla, Vía al mar', categories: ['Viales', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Obras Públicas'], imageUrl: projectImage4 },
  { id: 5, title: 'Sistema integrado de transporte masivo Metrocali', categories: ['Transporte y Energía', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Transporte Urbano'], imageUrl: projectImage5 },
  { id: 6, title: 'Interventoría Intersección a Desnivel de Puente Aranda', categories: ['Viales', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Puentes', 'Transporte Urbano'], imageUrl: projectImage6 },
  { id: 7, title: 'Interventoría al mantenimiento del Aeropuerto Vanguardia', categories: ['Aeroportuaria', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Aeropuertos'], imageUrl: projectImage7 },
  { id: 8, title: 'Interventoría al mantenimiento del Aeropuerto Alcaravan', categories: ['Aeroportuaria', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Aeropuertos'], imageUrl: projectImage8 },
  { id: 9, title: 'Interventoría Concesión Transversal del Sisga', categories: ['Viales', 'Inspecciones'], tags: ['Inspección y Supervisión de Obras', 'Obras Públicas'], imageUrl: projectImage9 },
];

// --- Hook personalizado para obtener el número de slides a mostrar (sin cambios) ---
const useSlidesPerView = () => {
    const [slidesPerView, setSlidesPerView] = useState(4);

    useLayoutEffect(() => {
        const updateSize = () => {
            if (window.innerWidth >= 1200) setSlidesPerView(4);
            else if (window.innerWidth >= 992) setSlidesPerView(3);
            else if (window.innerWidth >= 768) setSlidesPerView(2);
            else setSlidesPerView(1);
        };
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return slidesPerView;
};

// --- COMPONENTE INTERNO PARA LA TARJETA (sin cambios) ---
const ProjectCard = ({ project, onCardClick }) => (
    <div className="project-card" style={{ backgroundImage: `url(${project.imageUrl})` }} onClick={() => onCardClick(project)}>
        <div className="project-card-overlay">
            <div className="project-card-content">
                <div className="project-card-tags">
                    {project.tags.map(tag => <span key={tag} className="tag">{tag}</span>)}
                </div>
                <h3 className="project-card-title">{project.title}</h3>
            </div>
        </div>
    </div>
);


// --- COMPONENTE PRINCIPAL DE LA SECCIÓN (con className corregidos) ---
const ProyectosDestacados = () => {
    const [activeFilter, setActiveFilter] = useState('Todos');
    const [filteredProjects, setFilteredProjects] = useState(allProjects);
    const [currentIndex, setCurrentIndex] = useState(0);
    const slidesPerView = useSlidesPerView();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    const filters = ['Todos', 'Viales', 'Inspecciones', 'Transporte y Energía', 'Aeroportuaria'];

    useEffect(() => {
        const newFiltered = activeFilter === 'Todos'
            ? allProjects
            : allProjects.filter(p => p.categories.includes(activeFilter));
        setFilteredProjects(newFiltered);
        setCurrentIndex(0);
    }, [activeFilter]);
    
    const handleNext = () => {
        if (currentIndex < filteredProjects.length - slidesPerView) {
            setCurrentIndex(prevIndex => prevIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prevIndex => prevIndex - 1);
        }
    };

    const openModal = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProject(null);
        document.body.style.overflow = 'unset';
    };
    
    return (
        <section className="proyectos-section">
            <div className="proyectos-header">
                <h2 className="proyectos-title">Proyectos Destacados</h2>
                <div className="proyectos-filters">
                  {filters.map(filter => (
                    <button
                      key={filter}
                      className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                      onClick={() => setActiveFilter(filter)}
                    >
                      {filter}
                    </button>
                  ))}
                </div>
            </div>

            {/* --- Contenedor Unificado del Carrusel (CON CLASES CORREGIDAS) --- */}
            <div className="proyectos-carousel-container">
                <div className="proyectos-carousel-viewport">
                    <div
                        className="proyectos-carousel-track"
                        style={{
                            transform: `translateX(-${currentIndex * (100 / slidesPerView)}%)`
                        }}
                    >
                        {filteredProjects.map(project => (
                            <div className="proyectos-carousel-slide" key={project.id} style={{ flexBasis: `${100 / slidesPerView}%` }}>
                                <ProjectCard project={project} onCardClick={openModal} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* --- Botones de Navegación (CON CLASES CORREGIDAS) --- */}
                <button 
                  onClick={handlePrev} 
                  className="proyectos-carousel-nav prev" 
                  disabled={currentIndex === 0}
                >
                    &#10094;
                </button>
                <button 
                  onClick={handleNext} 
                  className="proyectos-carousel-nav next" 
                  disabled={currentIndex >= filteredProjects.length - slidesPerView}
                >
                    &#10095;
                </button>
            </div>

            {/* --- Renderiza el Modal si está abierto --- */}
            {isModalOpen && <ProjectDetailModal project={selectedProject} onClose={closeModal} />}
        </section>
    );
};

export default ProyectosDestacados;